// extracted by mini-css-extract-plugin
export var downArrow = "_8f-0";
export var label = "_8f-1";
export var treatmentCard = "_8f-3";
export var upArrow = "_8f-2";